module.exports = window.__IFENG_EXTERNALS__["react-no-ssr"];